import React, { useState } from 'react';
import '../css/problem-input.css';
import '../css/problem.css';
import { SubmitBar } from '../components/submit-bar';
import { APP_CFG } from '../appcfg';
import {
  showConfetti,
  submitResponse,
  moveOnToNextPage,
  setStage
} from '../redux/actions/ui';

import {
  Panel,
  setSideBarCorrect,
  setSideBarOpenPanel,
  setSideBarSecondTry,
  setSideBarIncorrect
} from '../sidebar-state';
import { getSecondTryHint, getReviewMessage, getCorrectElement } from '../components/side-bar';
import {
  ProblemStage,
  ITSEventType,
  FixedOptionData,
  FixedOptionComp
} from 'its-pages';
import { FixedOptionContent } from '../page-content/fixed-option-content';
import { useAppDispatch, useAppSelector } from '../redux/hooks';

interface InputProps {
  fixedOptionContent: FixedOptionContent;
}

export const FixedOption = (props: InputProps) => {
  const [firstTryScore, setFirstTryScore] = useState(0);
  const [disableSubmit, setDisableSubmit] = useState(true);

  const dispatch = useAppDispatch();
  const correctAnswerStreak = useAppSelector((state) => state.progression.correctAnswerStreak);
  const stage = useAppSelector((state) => state.ui.stage);
  const { fixedOptionContent } = props;

  const fixedOptionData = fixedOptionContent.pageData as FixedOptionData;

  const problemScore = () => fixedOptionContent.pageData.score;

  const isProblemCorrect = (): boolean => {
    return problemScore() === 1;
  };

  const isReview = stage === ProblemStage.ShowResult;
  const secondTry = stage === ProblemStage.SecondTry;

  const getReviewText = (): JSX.Element => {
    return (
      <div>
        {getReviewMessage(correctAnswerStreak, problemScore() > firstTryScore)}
      </div>
    );
  };

  const resetOptions = (): void => {
    if (APP_CFG.autoResetButtons) {
      fixedOptionData.reset();
    }
  };

  const onSubmit = () => {
    if (stage === ProblemStage.ShowResult) {
      dispatch(moveOnToNextPage());
    } else if (isProblemCorrect()) {
      dispatch(showConfetti(true));
      setSideBarCorrect(getCorrectElement(fixedOptionData.seed));
      dispatch(setStage(ProblemStage.ShowResult));
      dispatch(submitResponse());
    } else if (stage === ProblemStage.CollectInput) {
      dispatch(setStage(ProblemStage.SecondTry));
      setFirstTryScore(problemScore);
      setDisableSubmit(true);
      setSideBarSecondTry(getSecondTryHint(false));
      fixedOptionData.recordEvent(ITSEventType.firstTryWrong);
      resetOptions();
      // forceUpdate();
    } else if (stage === ProblemStage.SecondTry) {
      dispatch(setStage(ProblemStage.ShowResult));
      setSideBarIncorrect(getReviewText());
      dispatch(submitResponse());
    } else {
      dispatch(moveOnToNextPage());
    }
  };

  const onReviewed = () => {
    if (isReview) {
      setSideBarOpenPanel(Panel.None);
    }
  };

  const onChange = () => {
    setDisableSubmit(false);
  };

  return (
    <div className='Problem ProblemInput' style={{ padding: '0.5rem' }}>
      <FixedOptionComp
        stage={stage}
        pageData={fixedOptionData}
        onReviewed={onReviewed}
        onChange={onChange}
      />
      <SubmitBar
        onSubmit={onSubmit}
        buttonText={secondTry ? 'Try Again' : isReview ? 'Continue' : 'Submit'}
        buttonClass={'SubmitBarButton'}
        disableSubmit={disableSubmit}
        disabledTip={
          isReview
            ? undefined
            : secondTry
            ? 'Change your selection'
            : 'Make a selection'
        }
      />
    </div>
  );
};
